import { Modal, Button } from 'react-bootstrap';
import { useState } from "react";

export const NewProject = (props) => {

    const [projectName, setProjectName] = useState(props.defaultProjectName ?? "");

    const onHide = () => {
        setProjectName("");
    };

    return props.show ?
        (
            <Modal
                show={props.show}
                onHide={props.handleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label htmlFor="projectName">Project Name:</label>
                    <input className="form-control" id="projectName" placeholder='New Project' value={projectName} onInput={e => setProjectName(e.target.value)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { onHide(); props.handleCancel(); }}>
                        Cancel
                    </Button>
                    {projectName && projectName.length > 0 ?
                        <Button variant="primary" onClick={() => { props.handleSave(projectName); onHide(); }}>
                            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
                            Add
                        </Button> :
                        <>
                            Not Yet Valid
                        </>
                    }
                </Modal.Footer>
            </Modal>
        ) :
        (<></>);
}